module.exports = __webpack_public_path__ + "static/img/pizza.f7bfe64.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pizza.gif
// module id = eyit
// module chunks = 4